import {
  IS_SAVING,
  DISABLE_LANGUAGE_SELECTOR,
  IS_BUTTONS_VISIBLE,
  SET_GEO_POL_DATA,
  SET_COUNTRY_STATE_MAPPING_DATA,
} from "../constants";

export const isSavingToggle = (e) => ({
  type: IS_SAVING,
  payload: e,
});

export const disableLanguageSelectorToggle = (e) => ({
  type: DISABLE_LANGUAGE_SELECTOR,
  payload: e,
});

export const isButtonVisibleToggle = (e) => ({
  type: IS_BUTTONS_VISIBLE,
  payload: e,
});

export const setGeoPolData = (e) => ({
  type: SET_GEO_POL_DATA,
  payload: e,
});

export const setCountryStateMappingData = (e) => ({
  type: SET_COUNTRY_STATE_MAPPING_DATA,
  payload: e,
});
